import { useMemo } from 'react';
import * as R from 'remeda';
import { Skeleton, Tooltip, Typography } from '@rossum/ui/material';
import { truncateEmail } from '../../../../utils/truncateEmail';

type TruncatedEmailWithTooltipProps = {
  email: string;
};

const TruncatedEmailWithTooltip = ({
  email,
}: TruncatedEmailWithTooltipProps) => {
  const { truncatedEmail, showTooltip } = truncateEmail(email);

  return (
    <Tooltip title={showTooltip ? email : undefined} enterDelay={600}>
      <span>{` · ${truncatedEmail}`}</span>
    </Tooltip>
  );
};

type SecondaryRowProps = {
  id: number;
  email?: string;
  isEmailLoading?: boolean;
};

export const SecondaryRow = ({
  id,
  email,
  isEmailLoading,
}: SecondaryRowProps) => {
  const skeletonWidth = useMemo(() => R.randomInteger(100, 200), []);

  return (
    <Typography variant="body2" noWrap color="secondary" component="div">
      {id}
      {isEmailLoading ? (
        <Skeleton
          variant="text"
          width={skeletonWidth}
          sx={{ display: 'inline-block', ml: 0.5 }}
        />
      ) : email ? (
        <TruncatedEmailWithTooltip email={email} />
      ) : null}
    </Typography>
  );
};
